import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import { fetchCampusesRequest } from '../../actions/fetchCampusActions';
import Button from '../../components/Button';
import PageLayout from '../../components/PageLayout';
import SelectLoadingFetch from '../../components/SelectLoadingFetch';
import analytics from '../../lib/analytics';
import useCampuses from '../../lib/hooks/useCampuses';
import useSchools from '../../lib/hooks/useSchools';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const CampusPage = ({ dispatchAddPageData, dispatchFetchCampuses, dispatchWizardNav }) => {
  const { selected: selectedSchool } = useSchools();
  const { allCampuses: campuses, selectedCampus } = useCampuses();
  const [campus, setCampus] = useState(selectedCampus);

  useEffect(() => {
    const { value: schoolId } = selectedSchool;
    if (!campuses[schoolId]) {
      dispatchFetchCampuses(schoolId);
    }
  }, [selectedSchool, campuses, dispatchFetchCampuses]);

  const isInvalid = campus === null || campus === undefined;

  const handleSubmit = event => {
    event.preventDefault();

    if (isInvalid) {
      return;
    }

    analytics.sendEvent('Click - Next', 'campus');

    const payload = payloadFactory.createAddPageDataPayload(
      'campus',
      campus,
      'campusGuid',
      campus.value,
    );
    dispatchAddPageData(payload);
    dispatchWizardNav({ dir: 'fwd' });
  };

  return (
    <PageLayout title="Which campus do you want to go to?">
      <form onSubmit={handleSubmit}>
        <div className="row row--align-middle">
          <div className="col col--9/16-small">
            <SelectLoadingFetch
              single="campus"
              plural="campuses"
              onChange={setCampus}
              selected={campus}
              hook={useCampuses}
            />
          </div>
        </div>

        <div className="row-spacer">
          <Button type="submit" isDisabled={isInvalid}>
            Next
          </Button>
        </div>
      </form>
    </PageLayout>
  );
};

CampusPage.propTypes = {
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
  dispatchFetchCampuses: PropTypes.func.isRequired,
};

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchFetchCampuses: fetchCampusesRequest,
  dispatchWizardNav: navigateWizard,
};

export { CampusPage };

export default connect(null, mapDispatchToProps)(CampusPage);
